// 4-Karten-Stat-Row (Owner · Pro · Trial · Free) im 21st-Style mit
// Gradient-Border in Tier-Farbe. Doc 2026-05-17: TierStats wandert
// vom „Tier-Verwaltung"-Tab in „User-Liste".

import { Crown, Gem, Gift, User } from 'lucide-react';
import { motion } from 'framer-motion';
import type { AdminUserRow, UserTier } from '@/lib/admin-users-api';

interface UserStatsCardsProps {
  users: ReadonlyArray<AdminUserRow>;
}

const TIER_META: ReadonlyArray<{
  key: UserTier;
  label: string;
  icon: typeof Crown;
  accent: string;
}> = [
  {
    key: 'owner',
    label: 'Owner',
    icon: Crown,
    accent: 'border-amber-500/30 bg-amber-500/[0.06] text-amber-300',
  },
  {
    key: 'pro',
    label: 'Pro',
    icon: Gem,
    accent: 'border-emerald-500/30 bg-emerald-500/[0.06] text-emerald-300',
  },
  {
    key: 'trial',
    label: 'Trial',
    icon: Gift,
    accent: 'border-sky-500/30 bg-sky-500/[0.06] text-sky-300',
  },
  {
    key: 'free',
    label: 'Free',
    icon: User,
    accent: 'border-white/10 bg-white/[0.02] text-neutral-300',
  },
];

export function UserStatsCards({ users }: UserStatsCardsProps) {
  const counts = users.reduce<Record<UserTier, number>>(
    (acc, u) => {
      acc[u.tier] = (acc[u.tier] ?? 0) + 1;
      return acc;
    },
    { owner: 0, pro: 0, trial: 0, free: 0 },
  );
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {TIER_META.map((t, i) => (
        <motion.div
          key={t.key}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.05, type: 'spring', stiffness: 240, damping: 22 }}
          className={`rounded-2xl border p-4 ${t.accent}`}
        >
          <div className="flex items-center justify-between">
            <span className="text-[11px] font-bold uppercase tracking-wider">{t.label}</span>
            <t.icon className="size-4 opacity-70" />
          </div>
          <div className="mt-1 text-3xl font-bold tabular">{counts[t.key]}</div>
        </motion.div>
      ))}
    </div>
  );
}
